import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import EmailIcon from '@mui/icons-material/Email'
import { HelpCenterCardSupportButtonProps } from './_props'
import PhoneIcon from '@mui/icons-material/Phone'
import { sxs } from './_sxs'
import { constants } from '../../../utilities'

const HelpCenterCardSupportButton = ({ email = undefined, onEmailClick }: HelpCenterCardSupportButtonProps) => (
    <Box sx={[sxs.cardNoAction, email ? sxs.cardNoActionWithEmail : null]}>
        <Box sx={sxs.cardActionInnerContainer}>
            <PhoneIcon sx={sxs.buttonIconSecondary} />
            <Typography fontSize="1rem !important">Tél. : {constants.SUPPORT_PHONE}</Typography>
        </Box>

        {email && (
            <Box sx={sxs.cardActionInnerContainer}>
                <EmailIcon sx={sxs.buttonIconSecondary} />
                <Link href={`mailto:${email}`} sx={sxs.buttonInnerLink} onClick={onEmailClick}>
                    Mail : {email}
                </Link>
            </Box>
        )}

        <Typography textAlign="center">
            Du lundi au vendredi, de 08h30 à 18h (hors jours fériés français et alsaciens)
        </Typography>
    </Box>
)

export default HelpCenterCardSupportButton
